// mui components
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledHeading = styled(Typography)(({ theme }) => ({
  ...theme.fontStyles.h4,
  fontWeight: 400,
  textDecoration: 'unset',
}));
